/**
 * @name APP cmmApp
 * @autor camila.montenegro@u-planner.com
 * @description Tabla para Campus
 * # name controller --> tableCtrl
 */

	export default class tableintCtrl {


	constructor($scope, $http , $filter,tablesintServices,$stateParams,ngNotify,SERVICE_URL_CONSTANT,$window){

		function ucfirst(st){
			return st.substring(0, 1).toUpperCase() + st.substring(1).toLowerCase();
		}
		$scope.type=$stateParams['type'];
        $scope.title=$scope.type.replace( /([A-Z])/g, " $1" );//ucfirst();
        $scope.title=$scope.title.replace(/_/g, ' ' );//ucfirst();
		var vm=this;
		
		$scope.model={};
		//// Table

		$scope.tabla ={ 
            exporterCsvFilename: 'integration_table_'+ $scope.type +'.csv',
            exporterCsvColumnSeparator: ';',
            exporterMenuAllData: true, 
            exporterOlderExcelCompatibility: true,
            exporterPdfDefaultStyle: {fontSize: 7},
            exporterPdfTableStyle: {margin: [5, 5, 5, 5]},
            exporterPdfTableHeaderStyle: {fontSize: 8, bold: true, italics: true, color: 'blue'},
            exporterPdfMaxGridWidth: 620,
            exporterPdfCustomFormatter: function(docDefinition) {
                docDefinition.styles.headerStyle = {
                    fontSize: 15,
                    bold: true,
                    marginTop: 10,
                    marginLeft: 40,
                    marginBottom: 40
                };
                return docDefinition;
            },
			enableFiltering: true,
            enableGridMenu: true,
            paginationPageSizes: [10,25, 50, 75],
    		paginationPageSize: 10,
            useExternalPagination: true,
            onRegisterApi :function( gridApi ) {
                gridApi.core.on.filterChanged( $scope, function() {
                      var grid = this.grid;
                      var filters={}
                      
                      for(let i in grid.columns){
                          if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
                              filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
                          }
                      }
                      $scope.tabla.paginationNumber=1;
                      tablesintServices.services.getTabla({tabla:$scope.type,newPage:1, pageSize:$scope.tabla.paginationPageSize,filters:filters}).$promise
                                .then(function(data){
                                    $scope.tabla.data = data.data;
                                    $scope.tabla.totalItems = data.size;
                                });
                    });
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                      var grid = this.grid;
                      var filters={}
                      for(let i in grid.columns){
                          if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
                              filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
                          }
                      }
                      tablesintServices.services.getTabla({tabla:$scope.type,newPage:newPage, pageSize:pageSize,filters:filters}).$promise
                                .then(function(data){
                                    $scope.tabla.data = data.data;
                                    $scope.tabla.totalItems = data.size;
                                });
                  });
              }
            
			//columnDefs : cols
		};
		tablesintServices.services.getTabla({tabla:$scope.type,newPage:1, pageSize:10}).$promise
					.then(function(data){
						$scope.tabla.data = data.data;
                        $scope.tabla.totalItems = data.size;
					});
        var url=SERVICE_URL_CONSTANT.tablesFiltering+'/integrationExport?tabla='+$scope.type;
        vm.exportAll=function(){
            $window.open(url);
            
        }
	}
}

tableintCtrl.$inject = ['$scope', '$http' , '$filter','tablesintServices','$stateParams','ngNotify','SERVICE_URL_CONSTANT','$window'];





// WEBPACK FOOTER //
// ./src/app/integration-front/tablesint/tableintCtrl.js